<ng-container *transloco="let t">
  <pxw-input-radio-group
    class="payment-methods"
    name="paymentMethods"
    [label]="t('endOrder.paymentMethodLabel')"
    [helper]="restrictionHint() ?? ''"
    [options]="paymentMethods()"
    [labelKey]="'name'"
    [(ngModel)]="paymentMethod"
    required
    [displayErrors]="isFormSubmitted()"
    [messages]="{
      required: t('endOrder.paymentMethodRequired'),
    }"
    layout="inline"
  >
    <ng-template #radioItemTemplate let-paymentMethod>
      {{ paymentMethod.name }}

      @if (paymentMethod.discount) {
        <pxw-tag size="xs" type="success" class="payment-discount">
          {{ paymentMethod.discount }}% OFF
        </pxw-tag>
      }
    </ng-template>

    @let selectedPaymentMethod = paymentMethod();

    @if (selectedPaymentMethod) {
      <section class="payment-methods-alerts">
        @if (
          selectedPaymentMethod.extraCharge &&
          selectedPaymentMethod.extraCharge > 0 &&
          !installmentOptions()
        ) {
          <pxw-alert type="warning" display="inline-block" size="sm">
            <span
              [innerHTML]="
                t('endOrder.paymentMethodExtraChargeLabel', {
                  extraCharge: selectedPaymentMethod.extraCharge,
                })
              "
            ></span>
          </pxw-alert>
        }
        @if (selectedPaymentMethod.discount && selectedPaymentMethod.discount > 0) {
          <pxw-alert type="success" display="inline-block" size="sm">
            <span
              [innerHTML]="
                t('endOrder.paymentMethodDiscountLabel', {
                  discount: selectedPaymentMethod.discount,
                })
              "
            ></span>
            <pxw-icon icon="info" #customIcon></pxw-icon>
          </pxw-alert>
        }

        @if (installmentRadioOptions(); as radioOptions) {
          <div class="installment-selector">
            <label class="installment-selector-label"
              >{{ t('endOrder.installmentsLabel') }}
              <span class="installment-selector-required">*</span></label
            >
            <div class="installment-selector-options">
              @for (option of radioOptions; track option.value) {
                <label
                  class="installment-selector-option"
                  [class.installment-selector-option--selected]="
                    option.value === selectedInstallments()
                  "
                >
                  <input
                    type="radio"
                    name="installments"
                    [checked]="option.value === selectedInstallments()"
                    (change)="selectedInstallments.set(option.value)"
                  />
                  <span class="installment-selector-option-label">{{ option.label }}</span>
                  @if (option.surcharge) {
                    <pxw-tag size="xs" type="warning">+{{ option.surcharge }}%</pxw-tag>
                  }
                </label>
              }
            </div>
            <p class="installment-selector-hint">{{ t('endOrder.installmentsPaymentHint') }}</p>
          </div>
        }

        @if (displayLinkInfo() && selectedPaymentMethodIsLink()) {
          @let linkPm = linkPaymentMethod();
          @if (linkPm) {
            <pxw-alert
              class="payment-method-link-alert"
              type="info"
              display="inline-block"
              size="sm"
            >
              {{ t('endOrder.paymentMethodHasLink' + linkPm.type) }}
              <pxw-icon icon="info" #customIcon></pxw-icon>
            </pxw-alert>
          }
        }

        <!-- Bank Transfer Fields (handles both integration and manual transfer details) -->
        @if (shouldDisplayTransferFields()) {
          @let transferPm = transferPaymentMethod();
          @if (transferPm) {
            <pxw-end-order-bank-transfer-fields
              [paymentMethod]="transferPm"
              [finalAmount]="orderFinalAmount()"
              [establishmentId]="establishmentId()"
              [customerName]="customerName()"
              [availableIntegrations]="availableIntegrations()"
              [showTransferDetails]="showTransferDetails()"
              [transferReferenceId]="transferReferenceId()"
              [payerDocumentEnabled]="payerDocumentEnabled()"
              [isFormSubmitted]="isFormSubmitted()"
              [(transferPayer)]="transferPayer"
              (digitalPaymentChange)="onDigitalPaymentChange($event)"
            />
          }
        }
      </section>
    }
  </pxw-input-radio-group>

  @if (shouldDisplayHowMuchField()) {
    <pxw-input-number
      name="howMuch"
      format="currency"
      [label]="t('endOrder.paymentHowMuchLabel')"
      [placeholder]="t('endOrder.paymentHowMuchPlaceholder')"
      [(ngModel)]="howMuch"
      [displayErrors]="isFormSubmitted()"
      required
      [min]="orderFinalAmount()"
      [messages]="{
        min: t('endOrder.paymentHowMuchMin'),
      }"
    />
  }
</ng-container>
